import { Injectable } from "@angular/core";
import { ToastController } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class LoveItToastService {
  constructor(private toastController: ToastController) {}

  showToastMessage(message: string, errorCode?: number) {
    const toastPromise = this.toastController.create({
      message: `${message}`,
      duration: 0,
      cssClass: "interactive-toast",
      buttons: [
        {
          icon: "close",
          role: "cancel",
        },
      ],
    });

    toastPromise.then((toast) => {
      toast.present();
    });
  }
}
